export const TOGGLE_MARKER = 'TOGGLE_MARKER';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const TOGGLE_TYPE = 'TOGGLE_TYPE';
export const SET_TOGGLE_TYPES = 'SET_TOGGLE_TYPES';

export function toggleMarker(marker) {
  return {type: TOGGLE_MARKER, payload: marker};
}

export function toggleType(_type) {
  return {type: TOGGLE_TYPE, payload: _type};
}

export function setToggleTypes(categories) {
  return {type: SET_TOGGLE_TYPES, payload: categories};
}

export function toggleLoading() {
  return {type: TOGGLE_LOADING};
}



// WEBPACK FOOTER //
// ./src/actions/Map/mapActions.js